import {ButtonEvent} from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import SettingsModel from "slotworks/model/settings/settings-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import SmartButton, {SmartButtonFlag} from "slotworks/smart-button/smart-button";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import AutoplayModel from "slotworks/model/autoplay-model";

export default class PromoStopButtonBehaviour extends AbstractButtonBehaviour {
    private label: FlexiText;

    constructor() {
        super();
    }

    public init() {
        // Spin button

        Layers.SmartButton.setScene("promo").execute();

        this.button = Layers.SmartButton.getFlexiButton("spin_promo");
        this.label = Layers.SmartButton.getFlexiText("label-spin");
        Layers.SmartButton.getFlexiText("label-stop").setVisible(true);
        this.button.setVisible(true);
        this.button.setEnabled(true);
        this.label.setVisible(false);

        this.button.on(ButtonEvent.POINTER_DOWN, this.onDownListener);

        document.addEventListener("keyup", this.onKeyUpListener);
    }

    public destroy() {
        this.button.off(ButtonEvent.POINTER_DOWN, this.onDownListener);
        this.label.setVisible(true);
        document.removeEventListener("keyup", this.onKeyUpListener);

        super.destroy();
    }

    private onKeyUpListener = (event: any) => {
        if (SettingsModel.getSpaceToSpin()) {
            if (event.keyCode === 32) {
                this.stop();
            }
        }
    }

    private onDownListener = () => {
        this.stop();
    }

    private stop() {
        AutoplayModel.stop();
        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN,false);
        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS,true);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/promo-fs-stop-button-behaviour.ts